import {connect} from "react-redux";
import RaisePaymentUpdate from "./RaisePayment";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../../service/fileUpload/action";
import {bankListRequest, loanAccountRequest, loanTranchesRequest, loanPaymentRaiseUpdateRequest} from "../../../../../service/Dealer/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    bankListResponse: state.Dealer.bankListResponse,
    loanApplicationUpdateResponse: state.Dealer.loanApplicationUpdateResponse,
    loanAccountResponse: state.Dealer.loanAccountResponse,
    loanTranchesResponse: state.Dealer.loanTranchesResponse,
    loanPaymentRaiseUpdateResponse: state.Dealer.loanPaymentRaiseUpdateResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            bankListRequest,
            loanAccountRequest,
            loanTranchesRequest,
            loanPaymentRaiseUpdateRequest
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(RaisePaymentUpdate);
